var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 1.40625L8 2.6875L8.75 1.40625C9.25 0.53125 10.1562 0 11.1562 0H11.25C12.75 0 14 1.25 14 2.75C14 3.21875 13.875 3.625 13.6875 4H14.5C15.3125 4 16 4.6875 16 5.5V7.5C16 8.15625 15.5625 8.71875 15 8.9375V9V14C15 15.125 14.0938 16 13 16H3C1.875 16 1 15.125 1 14V9V8.9375C0.40625 8.71875 0 8.15625 0 7.5V5.5C0 4.6875 0.65625 4 1.5 4H2.28125C2.09375 3.625 2 3.21875 2 2.75C2 1.25 3.21875 0 4.75 0H4.8125C5.8125 0 6.71875 0.53125 7.21875 1.40625ZM14.5 5.5H11.25H9V7.5H13.5H14.5V5.5ZM7 5.5H4.75H1.5V7.5H2.5H7V5.5ZM7 9H2.5V14C2.5 14.2812 2.71875 14.5 3 14.5H7V9ZM9 14.5H13C13.25 14.5 13.5 14.2812 13.5 14V9H9V14.5ZM11.25 4C11.9375 4 12.5 3.46875 12.5 2.75C12.5 2.0625 11.9375 1.5 11.25 1.5H11.1562C10.6875 1.5 10.2812 1.75 10.0312 2.15625L8.9375 4H9H11.25ZM7 4H7.03125L5.9375 2.15625C5.71875 1.75 5.28125 1.5 4.8125 1.5H4.75C4.03125 1.5 3.5 2.0625 3.5 2.75C3.5 3.46875 4.03125 4 4.75 4H7Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.088daee0e65749fc44068d69e2e42bcd.svg";
export { ForwardRef as ReactComponent };